import {SDrawerOrModal} from "shj-components";
import {Button, Col, Form, Input, message, Row} from "antd";
import React, {useEffect, useState} from "react";
import {calculationResult, getFormulaRuleQlPredictInputVar} from "@/services/product.ts";

export default function CheckRule(props) {
  const [form] = Form.useForm()
  const {code = '', type = ''} = props;
  const [color, setColor] = useState('green')
  const [tagList, setTagList] = useState([])
  const [result, setResult] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (code) getTagList()
  }, [code]);

  const getTagList = () => {
    getFormulaRuleQlPredictInputVar({type, commonFormula: code}).then(res => {
      setTagList(res)
    })
  }

  // const extractCharactersInBracket = (str) => {
  //   const regex = /\[\[([^\]]+)\]\]/g;
  //   let matches;
  //   const result = [];
  //
  //   while ((matches = regex.exec(str)) !== null) {
  //     result.push(matches[1]); // 提取括号内的字符串
  //   }
  //   return result;
  // }

  const onCheckRule = () => {
    form.validateFields().then(values => {
      const paramMap = {}
      tagList?.forEach((item) => paramMap[item] = values[item]);
      setLoading(true)
      calculationResult({type, commonFormula: code, paramMap}).then(res => {
        console.log(res)
        setColor((res?.result || !res?.errorList?.length) ? 'green' : 'red')
        setResult(res?.result || (res?.errorList.length ? res.errorList?.join(',') : '暂无结果'))
      }).catch(err => {
        setColor('red')
        setResult(err.message)
        message.destroy()
      }).finally(() => setLoading(false))
    })
  }

  return <>
    <SDrawerOrModal
        title={'验证'}
        {...props}
        width={500}
        antdProps={{
          footer: [<Button onClick={() => onCheckRule()}
                           loading={loading}
                           disabled={loading || !tagList.length}
                           type={'primary'}
                           style={{margin: '10px 0'}}>验证</Button>]
        }}
    >
      {/*<div>请输入以下变量的值，多个变量英文,号隔开，输入完成，点击验证，查看输出是否正确即可</div>*/}
      <Form form={form} layout={'vertical'}>
        <Row style={{marginTop: 20}}>
          {tagList
              .map(item => <Col key={item} span={24}>
                <Form.Item required={true} rules={[{required: true, message: `${item}不能为空`}]} label={item}
                           name={item}>
                  <Input placeholder={`请输入${item}`} style={{width: '100%'}}/>
                </Form.Item>
              </Col>)}
          <Col span={24}>
            {result && <Form.Item label={'结果'}>
              <div placeholder={'点击验证预测结果'}
                   style={{
                     width: '100%',
                     padding: '11px',
                     border: `1px dashed ${color}`,
                     boxSizing: 'border-box',
                     borderRadius: '5px'
                   }}>{result}</div>
            </Form.Item>}
          </Col>
        </Row>
      </Form>
    </SDrawerOrModal>
  </>
}